import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";

import MediaRequests from "services/media";
import { setRemovedMediaId } from "redux/actions/Media";
import { DialogContent, DialogTitle } from "./EditMediaModalUtils";
import GridContainer from "@jumbo/components/GridContainer";
import {
  Box,
  Paper,
  Button,
  Dialog,
  Typography,
  CircularProgress,
  Grid,
} from "@material-ui/core";
import { makeStyles, lighten } from "@material-ui/core/styles";
import { Delete } from "@material-ui/icons";
import { Description } from "@material-ui/icons";
import { baseUrl } from "@jumbo/constants/baseUrl";

const useStyles = makeStyles((theme) => ({
  girdContainer: {
    width: "100%",
    margin: "0",
    padding: "0",
  },
  label: {
    fontWeight: "bold",
  },
  contentText: {
    textAlign: "right",
    fontSize: "14px",
    paddingRight: "16px",
    color: theme.palette.text.disabled,
    direction: 'rtl'
  },
  mediaLink: {
    display: "block",
    textAlign: "right",
    marginTop: "16px",
    paddingRight: "14px",
    direction: 'rtl'
  },
  paper: {
    width: "100%",
    height: "100%",
    maxHeight: "330px",
    backgroundColor: lighten(theme.palette.background.paper, 0.1),
    marginBlock: theme.spacing(2),
    padding: theme.spacing(2),
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  imageContainer: {
    width: "100%",
    height: "100%",
    objectFit: "contain",
  },
  fileIcon: {
    fontSize: "60px",
    marginBlock: "30px",
  },
  detailsContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
  },
  removeButtonContainer: {
    marginTop: "30px",
  },
}));

const EditMediaModal = ({
  open,
  handleClose,
  mediaData,
  mediaType,
  mediaExtention,
}) => {
  const classes = useStyles();
  const { loadingRemoveMedia, removedMediaId } = useSelector(
    ({ media }) => media
  );
  const dispatch = useDispatch();

  const getPreview = (mediaName, type, extension) => {
    let preview = null;
    if (type === "image") {
      preview = (
        <img
          crossOrigin="anonymous"
          className={classes.imageContainer}
          src={`${baseUrl}file/get/${mediaName}`}
          alt={mediaName}
        />
      );
    } else if (type === "video") {
      preview = (
        <video width="100%" height="300px" controls crossorigin="anonymous">
          <source src={`${baseUrl}file/get/${mediaName}`} type="video/mp4" />
          Your browser does not support the video tag
        </video>
      );
    } else if (type === "document") {
      preview = <Description className={classes.fileIcon} color="disabled" />;
    }
    return preview;
  };

  useEffect(() => {
    dispatch(setRemovedMediaId(""));
  }, []);

  useEffect(() => {
    if (removedMediaId !== "" && !loadingRemoveMedia) {
      dispatch(MediaRequests.getmediaList(1));
      handleClose();
    }
  }, [removedMediaId, loadingRemoveMedia]);

  return (
    <Dialog
      fullWidth={true}
      maxWidth={"lg"}
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <DialogTitle id="customized-dialog-title" onClose={handleClose} />
      <DialogContent>
        <GridContainer className={classes.girdContainer}>
          <Grid item xs={12} md={6} className={classes.detailsContainer}>
            <Box>
              <Typography gutterBottom className={classes.label}>
                نام رسانه :
              </Typography>
              <Typography gutterBottom className={classes.contentText}>
                {mediaData.name}
              </Typography>
              <Typography gutterBottom className={classes.label}>
                حجم رسانه :
              </Typography>
              <Typography gutterBottom className={classes.contentText}>
                {`(مگابایت) ${(mediaData.size / 1000000).toFixed(3)} `}
              </Typography>
              <Typography gutterBottom className={classes.label}>
                پیوند رسانه :
              </Typography>
              <a className={classes.mediaLink}>
                {`${baseUrl}file/get/${mediaData.name}`}
              </a>
            </Box>
            <Box className={classes.removeButtonContainer}>
              {loadingRemoveMedia ? (
                <CircularProgress />
              ) : (
                <Button
                  variant="contained"
                  color="secondary"
                  startIcon={<Delete />}
                  onClick={() =>
                    dispatch(MediaRequests.deleteMedia(mediaData._id))
                  }
                >
                  حذف
                </Button>
              )}
            </Box>
          </Grid>
          <Grid item xs={12} md={6}>
            <Paper elevation={4} className={classes.paper}>
              {getPreview(mediaData.name, mediaType, mediaExtention)}
            </Paper>
          </Grid>
        </GridContainer>
      </DialogContent>
    </Dialog>
  );
};

export default EditMediaModal;
